module.exports = __webpack_public_path__ + "static/media/image_28.651fdaa4.png";